<template>
  <div class="page-wrapper">
    <!-- 手册列表 -->
    <div class="container">
      <header>
        <div class="header-text">
          <h1 class="h1-text">威法定制家居</h1>
          <p>服务和保养手册预览</p>
        </div>
      </header>
      <div class="divider-vertical"></div>
      <main>
        <div class="download-section">
          <div class="download-item">
            <img src="/pdf/sofa-image.png" alt="沙发图片" class="product-image" />
            <div class="manual-info">
              <div class="title">
                <img src="/pdf/vifa-icon.png" alt="图标" class="icon" />
                <div class="text-content">
                  <h2><strong>沙发保养手册</strong></h2>
                  <p><strong>Sofa Care Manual</strong></p>
                </div>
              </div>

              <button
                  class="download-button"
                  @click="previewPdf('https://vifawebsite.oss-cn-hangzhou.aliyuncs.com/pdf/sofa-care-manual.pdf')"
              >
                下载
              </button>
            </div>
          </div>

          <div class="divider-vertical"></div>

          <div class="download-item">
            <img src="/pdf/product-image.png" alt="产品图片" class="product-image" />
            <div class="manual-info">
              <div class="title">
                <img src="/pdf/vifa-icon.png" alt="图标" class="icon" />
                <div class="text-content">
                  <h2><strong>产品保养手册</strong></h2>
                  <p><strong>Product Care Manual</strong></p>
                </div>
              </div>

              <button
                  class="download-button"
                  @click="previewPdf('https://vifawebsite.oss-cn-hangzhou.aliyuncs.com/pdf/product-care-manual.pdf')"
              >
                下载
              </button>
            </div>
          </div>
        </div>
      </main>
    </div>
  </div>
</template>


<script setup>
// 引入必要的Vue API
import { onMounted } from 'vue'

// 预览PDF函数
function previewPdf(pdfUrl) {
  // 给实际文件加时间戳，防止微信等浏览器缓存
  const realUrl = pdfUrl + (pdfUrl.includes('?') ? '&' : '?') + 't=' + Date.now();
  const previewUrl = `/pdfjs-viewer.html?file=${encodeURIComponent(realUrl)}`;
  window.location.href = previewUrl;
}

// 组件挂载
onMounted(() => {
  console.log('手册下载页面已加载')
})
</script>


<style scoped>
/* 页面特定样式，不影响全局 */

.page-wrapper {
  width: 100%;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}





/* 手册列表容器样式 */
.page-wrapper .container {
  padding: 16rem 0;
}

.container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}

header {
  text-align: center;
  margin-bottom: -5rem;
  width: 100%;
}

.header-text {
  text-align: center;
  margin: 0 auto;
}

.header-text h1 {
  font-size: 1.5rem;
  font-weight: 550;
  color: #000000;
  font-family: 'Source Han Sans CN', 'Noto Sans CJK SC', 'Microsoft YaHei', sans-serif;
  margin-bottom: 0.5rem;
  white-space: nowrap;
  display: flex;
  align-items: center;
  justify-content: center;
}

.header-text h1::before,
.header-text h1::after {
  content: '';
  width: 3rem;
  height: 1px;
  background-color: #000000;
  margin: 0 1rem;
}

.header-text p {
  font-size: 2.2rem;
  font-weight: 550;
  color: #000000;
  font-family: 'Source Han Sans CN', 'Noto Sans CJK SC', 'Microsoft YaHei', sans-serif;
  margin: 0;
  margin-top: 1rem;
  white-space: nowrap;
  letter-spacing: 0.1rem;
}



.download-section {
  width: 100%;
  max-width: 900px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

.download-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  width: 100%;
}

.product-image {
  width: 100%;
  max-width: 420px;
  height: auto;
  object-fit: cover;
  border-radius: 4px;
  margin-top: 20px;
}
.h1-text{
  font-size: 1.2rem;
}
.manual-info {
  width: 100%;
  max-width: 560px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
  margin-top: 2.5rem;
}

.title {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-direction: row;
  justify-content: center;
  width: 100%;
  margin: 0 auto;
}

.icon {
  width: 60px;
  height: 60px;
  object-fit: contain;
  flex-shrink: 0;

}

.text-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: left;
}

h2 {
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 0.2rem;
}

h2 strong {
  font-weight: 550;
  color: #000000;
  font-family: 'Source Han Sans CN', 'Noto Sans CJK SC', 'Microsoft YaHei', sans-serif;
  white-space: nowrap;
}

p strong {
  font-weight: 550;
  color: #000000;
  font-family: 'Source Han Sans CN', 'Noto Sans CJK SC', 'Microsoft YaHei', sans-serif;
  white-space: nowrap;
}
@media screen and (max-width: 768px) {
  .page-wrapper{
    padding: 0rem 0rem 10rem 0rem ;
  }
}

p {
  font-size: 1rem;
  color: #767676;
}

.download-button {
  width: auto;
  max-width: 200px;
  min-width: 9rem;
  text-align: center;
  padding: 1.5rem 2rem;
  background-color: #ffffff;
  color: #000000;
  border: 1px solid #000000;
  border-radius: 0;
  text-decoration: none;
  font-size: 1.5rem;
  font-weight: 550;
  font-family: 'Source Han Sans CN', 'Noto Sans CJK SC', 'Microsoft YaHei', sans-serif;
  transition: all 0.3s ease;
  display: block;
  margin: 0 auto;
  cursor: pointer;
}

.download-button:hover {
  background-color: #f8f8f8;
  border-color: #555555;
}

.file-info {
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
  color: #666666;
  font-family: 'Source Han Sans CN', 'Noto Sans CJK SC', 'Microsoft YaHei', sans-serif;
}

.file-type,
.file-size {
  background-color: #f5f5f5;
  padding: 0.2rem 0.5rem;
  border-radius: 3px;
  font-size: 0.8rem;
}



.divider-vertical {
  width: 3px;
  height: 30px;
  background-color: #f39c12;
  margin: 1rem auto;
  margin-top: 8rem;
}

@media (max-width: 768px) {
  .download-section {
    gap: 0.5rem;
  }

  .divider-vertical {
    height: 20px;
    width: 2px;
    margin: 0.8rem auto;
    margin-top: 10rem;
  }

  /* 保持在移动端图标和文字也在同一行 */
  .title {
    gap: 0.5rem;
  }

  /* 移动端下载按钮底部间距 */
  .download-button {
    margin-bottom: 3rem;
  }
}
</style>
